import { render, staticRenderFns } from "./approvalInstanceDrawer.vue?vue&type=template&id=a9bca7de&scoped=true"
import script from "./approvalInstanceDrawer.vue?vue&type=script&lang=js"
export * from "./approvalInstanceDrawer.vue?vue&type=script&lang=js"
import style0 from "./approvalInstanceDrawer.vue?vue&type=style&index=0&id=a9bca7de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9bca7de",
  null
  
)

export default component.exports